import * as constants from "./constants"
import * as components from "./components"
import * as containers from "./containers"

const content = { constants, components, containers }
export default content

export const ResetPassword = containers.ResetPassword
